var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boleto", attrs: { id: "boleto" } }, [
    _c("img", { attrs: { src: "/static/boleto.svg" } }),
    _vm._v(" "),
    _c("h3", [_vm._v("Você quer mesmo gerar o boleto?")]),
    _vm._v(" "),
    _vm.error
      ? _c("div", { staticClass: "warning" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e(),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "Ao gerar o boleto não será mais possível pagar pelo cartão de crédito!"
      )
    ]),
    _vm._v(" "),
    _vm.displayPaymentVoucherNotice
      ? _c("div", [
          _c("hr"),
          _vm._v(" "),
          _c("p", { staticClass: "warning" }, [
            _vm._v(
              "\n      Você deverá enviar o comprovante de pagamento através de ticket pois o seu pedido tem menos de " +
                _vm._s(_vm.daysToProvePayment) +
                " dias úteis de antecedência.\n    "
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "btn-group" }, [
      _c(
        "button",
        {
          staticClass: "btn bg-purple-outline",
          on: { click: _vm.resetPayment }
        },
        [_vm._v("Não, quero voltar")]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn bg-purple", on: { click: _vm.submit } },
        [_vm._v("Sim, quero gerar o boleto")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a479517a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a479517a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/CheckoutMobile/Payment/PaymentOptions/Boleto.vue
// module id = null
// module chunks = 